
import { Component, Prop } from 'vue-property-decorator';
import Booking from '@/views/Booking.vue';

@Component({
   components: {
      CHeader: () => import('@/components/Header.vue'),
   },
})
export default class View extends Booking {
   @Prop({ type: [Boolean], default: true }) create_action!: boolean;
   @Prop({ type: [Boolean], default: false }) copy_action!: boolean;
   @Prop({ type: [Boolean], default: false }) remove_action!: boolean;

   @Prop({ type: [Boolean], default: false }) is_archived!: boolean;
   @Prop({ type: [Boolean], default: false }) fixed!: boolean;
}
